'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var MainController = function MainController($scope, $animate, localStorageService, $timeout, $rootScope, $alert, APP) {
    _classCallCheck(this, MainController);

    $scope.theme_colors = ['pink', 'red', 'black'];

    $scope.fillinContent = function () {
        $scope.htmlContent = 'content content';
    };

    // theme changing
    $scope.changeColorTheme = function (cls) {
        $rootScope.$broadcast('theme:change', 'Choose template'); //@grep debug
        $scope.theme.color = cls;
    };

    $scope.changeTemplateTheme = function (cls) {
        $rootScope.$broadcast('theme:change', 'Choose color'); //@grep debug
        $scope.theme.template = cls;
    };

    if (!localStorageService.get('theme')) {
        var theme = {
            color: 'theme-black',
            template: 'theme-template-light'
        };

        localStorageService.set('theme', theme);
    }

    localStorageService.bind($scope, 'theme');

    console.log(APP);

    /*
    var introductionAlert = $alert({
        title: 'Welcome',
        content: '',
        placement: 'top-right',
        type: 'theme',
        container: '.alert-container-top-right',
        show: false,
        template: 'assets/html/layout/alert-introduction.html',
        animation: 'mat-grow-top-right'
    });
    
    
    if (!localStorageService.get('alert-introduction')) {
        $timeout(() => {
            $scope.showNotification();
            localStorageService.set('alert-introduction', 1);
        }, 2500);
    }
    
    $scope.showNotification = () => {
        introductionAlert.show();
    };
    */
};

exports['default'] = MainController;

MainController.$inject = ['$scope', '$animate', 'localStorageService', '$timeout', '$rootScope', '$alert', 'APP'];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./resources/assets/js/src/modules/markup/main_controller.js
 ** module id = 37
 ** module chunks = 0
 **/